import React, { useEffect } from "react";
import Helmet from "react-helmet";
import HomepageLayout from "src/layouts/homepage";
import JSONData from "branding/site-metadata.json";
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import "./pp.css"; // Import CSS file here

export default function Privacy() {

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <HomepageLayout>
            <Helmet data={JSONData}><title>Privacy Policy</title></Helmet>
            <header style={{ background: "#222", width: "100%", padding: "20px", textAlign: "center" }}>
                <img src="/img/logo.png" alt="Easyview logo" />
            </header>
            <main className="content-wrapper">
                <div className="container">
                    <div
                        name="termly-embed"
                        data-id="7e71c5c7-5e8f-4929-846b-a8b949b64610"
                        data-type="iframe"
                    ></div>
                </div>
            </main>
            <RawFooter />
        </HomepageLayout>
    );
}
